<template>
  <div class="descriptions">
    <PlateTitle
      :title="title"
      :subtitle="subtitle"
    >
      <template slot="extra">
        <slot name="extra" />
      </template>
    </PlateTitle>
    <a-descriptions
      class="main"
      :column="1"
    >
      <a-descriptions-item
        :label="getFieldName(key)"
        v-for="(value, key) in dataSource"
        :key="key"
        class="descriptionsItem"
      >
        <template v-if="!pictureFieldList.includes(key)">
          {{ getFieldValue(key) }}
        </template>
        <template v-else>
          <a-upload
            list-type="picture-card"
            :file-list="getFieldValue(key)"
            @preview="handlePreview"
          />
          <a-modal
            :visible="previewVisible"
            :footer="null"
            @cancel="handleCancel"
          >
            <img
              alt="example"
              style="width: 100%"
              :src="previewImage"
            >
          </a-modal>
        </template>
      </a-descriptions-item>
    </a-descriptions>
  </div>
</template>

<script>
import { Descriptions } from 'ant-design-vue';
import PlateTitle from '@/components/PlateTitle';
import { dateFormat, amountFormat } from '@/utils/format';
import jpg from '../assets/image/8.jpg';

function getBase64(file) {
  return new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.readAsDataURL(file);
    reader.onload = () => resolve(reader.result);
    reader.onerror = error => reject(error);
  });
}
export default {
  name: 'Description',
  components: {
    PlateTitle,
    aDescriptions: Descriptions,
    aDescriptionsItem: Descriptions.Item,
  },
  props: {
    title: {
      type: String,
      default: '',
    },
    subtitle: {
      type: String,
      default: '',
    },
    dataSource: {
      type: Object,
      default() {
        return {};
      },
    },
    pictureFieldList: {
      type: Array,
      default() {
        return [];
      },
    },
    timeFieldList: {
      type: Array,
      default() {
        return [];
      },
    },
    amountFieldList: {
      type: Array,
      default() {
        return [];
      },
    },
  },
  data() {
    return {
      jpg,
      previewVisible: false,
      previewImage: '',
      projectFieldNameMap: {
        orderNo: '项目名称',
        entName: '投标企业名称',
        creditCode: '投标企业统一社会信用代码',
        basicBank: '基本户开户行',
        basicBankNum: '基本户账号',
        basicFile: '基本户影像文件',
        businessFile: '企业营业执照',
        authTime: '担保授权书有效期限',
        authFile: '投保授权书',
        legalFile: '法人身份证',
        authPersonFile: '授权人身份证',
      },
    };
  },
  mounted() {
  },
  methods: {
    handleCancel() {
      this.previewVisible = false;
    },
    async handlePreview(file) {
      if (!file.url && !file.preview) {
        file.preview = await getBase64(file.originFileObj);
      }
      this.previewImage = file.url || file.preview;
      this.previewVisible = true;
    },
    getFieldName(key) {
      const map = {
        projectName: '项目名称',
        entName: '投标企业名称',
        entCreditCode: '投标企业统一社会信用代码',
        companyName: '投保人名称',
        creditCode: '投标人统一社会信用代码',
        authFile: '投保授权书',
        tenderName: '招标人名称',
        tenderCode: '招标人统一社会信用代码',
        tenderAddress: '招标人地址',
        tenderContactPhone: '招标人联系电话',
        sectionName: '标段名称',
        sectionCode: '标段编号',
        limit: '保险期限',
        insuranceSum: '保证金金额',
        bidDocReferEndTime: '项目开标截止时间',
        bidOpenTime: '项目开标截止时间',
        basicBank: '基本户开户行',
        basicBankNum: '基本户账号',
        basicFile: '基本户影像文件',
        businessFile: '企业营业执照',
        authTime: '担保授权书有效期限',
        legalFile: '法人身份证',
        authPersonFile: '授权人身份证',
        payOpenTime: '支付截至时间',
        appCompanyAddress: '公司地址',
        appCompanyPhone: '公司电话',
        identifyStart: '营业执照有效期',
        legalName: '法人姓名',
        legalCertNo: '法人证件号',
      };

      return map[key] || key;
    },
    getFieldValue(key) {
      const value = this.dataSource[key];
      if (this.timeFieldList.includes(key)) {
        return dateFormat(value);
      }
      if (this.amountFieldList.includes(key)) {
        return amountFormat(value);
      }
      if (this.pictureFieldList.includes(key)) {
        return value.map((item, index) => {
          return {
            name: 'image.png',
            status: 'done',
            url: item,
            uid: String(index),
          };
        });
      }
      return value;
    },
  },
};
</script>
<style lang="less" scoped>
.main{
  margin-top: 50px;
}
/deep/ .ant-descriptions-item-label{
  width: 240px;
  text-align: left;
  padding-right: 22px;
  color: #666;
  font-size: 14px;
  &::after{
    display: none;
  }
}
/deep/ .ant-descriptions-item-content{
  font-size: 14px;
  color: #333;
}
/deep/ .ant-descriptions-item{
    padding-bottom: 20px;
    display: flex;
    align-items: flex-start;
}
/deep/ .ant-upload-list-picture-card-container {
  width: 80px;
  height: 80px;
}
/deep/ .ant-upload-list-item {
  width: 80px;
  height: 80px;
}
/deep/ .anticon[tabindex] {
  display: none;
}
</style>
